export default __webpack_public_path__ + "static/media/logo.a380a6c1.svg";